import { AnimationActionTypes, ADD_ANIMATION, EDIT_NAME_ANIMATION, DELETE_ANIMATION, RESET_ANIMATION, ACTIVATE_ANIMATION, AddAnimationPayloadInterface, CHANGE_KEY_CONTROLS, PLAY_STOP, SWIPE_ANIMATION } from "../../Actions/Animator/animation.list.action";
import { ADD_SPRITE_TO_FRAMES, ACTIVATE_FRAME, DELETE_FRAME, FrameListTypes, SWIPE_FRAME } from "../../Actions/Animator/frames.list.action";
import { RESET_ALL } from "../../Actions/globals.actions";
import preventAnimationNameDuplicate from '../../../utils/preventAnimationNameDuplicate';

export type ActionAnimationList = {
    actual_animation: string;
    animations: Array<AddAnimationPayloadInterface>
}

const defaultAnimationList: ActionAnimationList = {
    actual_animation: '0',
    animations: []
};

type ActionsTypes = AnimationActionTypes & FrameListTypes;

const AnimationList = (state = defaultAnimationList, action: ActionsTypes) => {
    switch (action.type) {
        case ACTIVATE_ANIMATION: {
            return {
                ...state,
                actual_animation: action.payload.id,
                animations:  state.animations.map((animation: any) => {
                    return (animation.play = false, animation) 
                })
            }
        }

        case ADD_ANIMATION: {
            let animation =  action.payload;
            animation.name = preventAnimationNameDuplicate(action.payload, state);
            return {
                actual_animation: action.payload.id,
                animations: [action.payload, ...state.animations]
            }
        }

        case SWIPE_ANIMATION: {
            return {
                ...state,
                animations: action.payload
            }
        }

        case CHANGE_KEY_CONTROLS: {
            return {
                ...state,
                animations: state.animations.map((animation: any) => (animation.id === action.payload.id) ? (animation.key_controls = action.payload.key_controls, animation) : animation)
            }
        }

        case EDIT_NAME_ANIMATION: {
            
            return {
                ...state,
                animations: state.animations.map((animation: any) => (animation.id === action.payload.id) ? (animation.name = preventAnimationNameDuplicate(action.payload,state), animation) : animation)
            }
        }

        case DELETE_ANIMATION: {
            const new_state = {
                ...state,
                animations: state.animations.filter((animation: any) => (animation.id !== action.payload.id))
            };
            new_state.actual_animation = (state.animations.length > 1) ? state.animations[0].id : '0';
            return new_state;
        }

        // Frames
        case ADD_SPRITE_TO_FRAMES: {
            return {
                ...state,
                animations: state.animations.map((frames: any) => {
                    frames.frames = frames.frames.map((frame: any) => {
                        frame.active = false;
                        return frame;
                    });

                    if (action.payload.id === frames.id) {
                        frames.frames.push(action.payload.sprite);
                    }
                    return frames;
                })
            }
        }

        case SWIPE_FRAME: {
            return {
                ...state,
                animations: state.animations.map((frames: any) => {
                    if (frames.id === action.payload.id) {
                        frames.frames = action.payload.frames
                    }
                    return frames;
                })
            }
        }

        case ACTIVATE_FRAME: {
            return {
                ...state,
                animations: state.animations.map((frames: any) => {
                    frames.frames = frames.frames.map((frame: any) => {
                        if (frame.local_id === action.payload.local_id) {
                            frame.active = true;
                        } else {
                            frame.active = false;
                        }
                        return frame;
                    });
                    return frames;
                })
            }
        }

        case PLAY_STOP: {
            return {
                ...state,
                animations: state.animations.map((animation: any) => {
                    if (animation.id === action.payload.id) {
                        animation.play = action.payload.play;
                    } else {
                        animation.play = false;
                    }
                    return animation;
                })
            }
        }

        case DELETE_FRAME: {
            const state_animations = state.animations.map((frames: any) => {
                frames.frames = frames.frames.filter((frame: any) => (frame.local_id !== action.payload.local_id));
                return frames;
            });
            return { ...state, animations: state_animations }
        }

        case RESET_ANIMATION: {
            return defaultAnimationList;
        }

        case RESET_ALL: {
            return defaultAnimationList;
        }

        default:
            return state;
    }
}

export default AnimationList;